import * as Actions from "../../actions/billing/billing";

const initialstate = {
  isLoading: false,
  error: false,
  invoiceNumber: "",
  currentBill: [],
  contractAccounts: [],
  contractId: "",
  contractAccount: "",
  quickBill: {},
  currencySymbol: "",
  contractAccountCallResponse: [],
  isFooterEnabled: true,
};

export default (state = initialstate, action) => {
  switch (action.type) {
    // case Actions.BILLING: {
    //     return{
    //         ...state,
    //         isLoading:true
    //     }
    // }
    // case Actions.BILLING_SUCCESS: {
    //     return {
    //         ...state,
    //         isLoading: false,
    //         error: false
    //     }
    // }
    // case Actions.BILLING_FAILURE: {
    //     return {
    //         ...state,
    //         isLoading:false,
    //         error:action.error,
    //     }
    // }
    case Actions.SET_CONTRACT_ACCOUNT: {
      return {
        ...state,
        contractAccount: action.data,
      };
    }
    case Actions.SET_CONTRACT_ACCOUNTS: {
      return {
        ...state,
        contractAccounts: action.data,
      };
    }
    case Actions.INVOICENUMBER: {
      return {
        ...state,
        invoiceNumber: action.invoiceNumber,
        isLoading: true,
      };
    }
    case Actions.GETCURRENTBILL:
    case Actions.GETCONTRACTACCOUNT:
    case Actions.GETQUICKBILL: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case Actions.GETCURRENTBILL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        currentBill: action.data,
        error: false,
      };
    }
    case Actions.GETCURRENTBILL_FAILURE: {
      //changed by me
      return {
        ...state,
        isLoading: false,
        currentBill: [],
        error: action.error,
      };
    }
    case Actions.GETCONTRACTACCOUNT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        contractAccounts: action.data,
        error: false,
      };
    }
    case Actions.GETCONTRACTACCOUNT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }
    case Actions.GETCONTRACTID: {
      return {
        ...state,
        contractId: action.contractId,
        isLoading: true,
      };
    }
    case Actions.GETQUICKBILL_SUCCESS: {
      return {
        ...state,
        isLoading: false,

        quickBill: {
          currency: action.data.data.data[0].currency,
          priorCharges: action.data.data.data[0].priorCharges,
          unappliedPaymentsAndAdjustments: action.data.data.data[0].unappliedPaymentsAndAdjustments,
          totalOutstandingCharges: action.data.data.data[0].totalOutstandingCharges,
          totalCurrentCharges: action.data.data.data[0].totalCurrentCharges,
          monthlyRecurringCharges: action.data.data.data[0].monthlyRecurringCharges,
          professionalServices: action.data.data.data[0].professionalServices,
          equipmentCharges: action.data.data.data[0].equipmentCharges,
          taxesAndSurcharges: action.data.data.data[0].taxesAndSurcharges,
          dueDate: action.data.data.data[0].dueDate,
          invoiceNumber: action.data.data.data[0].invoiceNumber,
          totalAmountDue: action.data.data.data[0].totalAmountDue,
          currencyCode: action.data.data.data[0].currencyCode,
          companyCode: action.data.data.data[0].companyCode,
        },
        currencySymbol: action.currencySymbol,
        error: false,
      };
    }
    case Actions.GETQUICKBILL_FAILURE: {
      return {
        ...state,
        isLoading: false,
        quickBill: {},
        currencySymbol: "",
        error: action.error,
      };
    }
    case Actions.RESET_QUICK_BILL: {
      return {
        ...state,
        quickBill: {},
        currencySymbol: "",
      };
    }
    case Actions.RESET: {
      return initialstate;
    }
    case Actions.SETCONTRACTACCOUNTCALL_RESPONSE: {
      return {
        ...state,
        contractAccountCallResponse: action.data,
      };
    }
    case Actions.SETFOOTERENABLED: {
      return {
        ...state,
        isFooterEnabled: action.data,
      };
    }
    default:
      return state;
  }
};
